module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("h5tC9"))).then(() => parcelRequire('d0iPb'));